import * as d3 from 'd3-selection'

const wrap = function (selection) {
  selection.each(function () {
    var rect = d3.select(this)
                 .selectAll('rect.hover-container').data(d => d.hoverText ? [d.hoverText] : [])
      , enter = rect.enter()
                    .append('rect')
                      .attr('class', 'hover-container')
                      .attr('width', '100%')
                      .attr('height', '100%')

    enter.append('title')

    rect.merge(enter).selectAll('title')
                     .data(d => [d])
                     .text(String)

    rect.exit().remove()
  })
}

export default wrap
